import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingbusbookingonlinepune() {



  const cardData =
  {
    keyword: 'Wedding Bus Booking Online Pune',
    heading: 'Amruta Travels: Wedding Bus Booking Online Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. provides Wedding Bus Booking Online in Pune, offering elegant and comfortable transport solutions for your special day. Whether it’s guest pickups, bride and groom travel, or outstation wedding transfers, our fleet of luxury AC and Non-AC buses ensures a smooth and stylish experience for everyone. Each bus features plush interiors, push-back seats, strong air conditioning, and ample space to make every journey relaxed and enjoyable. With easy online booking, professional chauffeurs, and on-time service, we make wedding transportation completely hassle-free. From Baner, Hadapsar, and Kothrud to Pimpri Chinchwad, Amruta Travels’ Wedding Bus Rental in Pune is the trusted choice for elegant, reliable, and well-coordinated travel arrangements for your big day.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
    {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "Wedding Bus Booking Online Pune",
      "description": "Wedding Bus Booking Online Pune offers a seamless digital platform for reserving buses specifically tailored for weddings. Customers can easily choose from various bus types, seating capacities, and amenities, ensuring a hassle-free booking experience. Instant confirmations, flexible payment options, and 24/7 support make planning wedding transportation convenient and stress-free."
    },
    {
      "name": "Wedding Bus Hire Pune",
      "description": "Wedding Bus Hire Pune specializes in providing reliable and elegant bus rental services for wedding events. With a fleet of well-maintained buses, experienced drivers, and customizable decoration options, this service ensures smooth transportation for guests between venues, hotels, and other locations, adding convenience and grace to your special day."
    },
    {
      "name": "Marriage Bus Rental Pune",
      "description": "Marriage Bus Rental Pune delivers comprehensive bus rental solutions for weddings and related ceremonies. The service offers a variety of buses equipped to handle different group sizes, focusing on comfort, safety, and timely service. Professional drivers and well-kept vehicles ensure your wedding logistics run smoothly."
    },
    {
      "name": "AC Wedding Bus Pune",
      "description": "AC Wedding Bus Pune provides fully air-conditioned buses for wedding guests, ensuring a cool and comfortable journey regardless of Pune’s climate. Ideal for summer weddings or long-distance travel, these buses feature spacious interiors and smooth rides, enhancing guest satisfaction and comfort throughout the event."
    },
    {
      "name": "Non AC Wedding Bus Pune",
      "description": "Non AC Wedding Bus Pune offers economical and reliable non-air-conditioned buses for wedding transportation. Suitable for budget-conscious clients or shorter trips within the city, these buses maintain cleanliness and safety standards while providing practical solutions for guest travel during wedding festivities."
    },
    {
      "name": "Luxury Wedding Bus Pune",
      "description": "Luxury Wedding Bus Pune presents upscale bus rentals featuring plush interiors, elegant decor, and premium amenities tailored for weddings. Perfect for transporting the bridal party, close family members, or VIP guests, these buses combine comfort and style to enhance the wedding experience with a touch of sophistication."
    },
    {
      "name": "35 Seater Wedding Bus Pune",
      "description": "35 Seater Wedding Bus Pune offers mid-sized buses that accommodate moderate-sized wedding groups comfortably. These buses are well-maintained, equipped with essential amenities, and operated by professional drivers, ensuring timely and safe transport during your wedding celebrations."
    },
    {
      "name": "45 Seater Wedding Bus Pune",
      "description": "45 Seater Wedding Bus Pune features spacious buses ideal for larger wedding parties. With ample seating and luggage space, these buses provide reliable and comfortable transportation for guests attending weddings, receptions, and related events, ensuring smooth logistics on your special day."
    },
    {
      "name": "53 Seater Wedding Bus Pune",
      "description": "53 Seater Wedding Bus Pune offers large-capacity buses designed to transport sizable wedding groups efficiently. These vehicles are equipped with comfortable seating, safety features, and driven by experienced chauffeurs, ensuring a safe, punctual, and comfortable journey for all wedding attendees."
    },
    {
      "name": "Mini Wedding Bus Pune",
      "description": "Mini Wedding Bus Pune caters to smaller wedding parties or close-knit guest groups with compact and cozy mini buses. These vehicles provide personalized and convenient transport solutions for intimate weddings or side events, ensuring comfort and style on a smaller scale."
    },
    {
      "name": "Wedding Bus Hire in Baner",
      "description": "Wedding Bus Hire in Baner serves the Baner locality with specialized wedding bus rental services. Known for punctuality, well-maintained vehicles, and courteous drivers, this service caters to local wedding events, ensuring smooth transportation of guests across venues in Baner and nearby areas."
    },
    {
      "name": "Wedding Bus Hire in Hinjewadi",
      "description": "Wedding Bus Hire in Hinjewadi focuses on the IT and corporate hub area, providing reliable and elegant bus rentals for weddings. This service accommodates guests attending ceremonies, receptions, and related events in Hinjewadi with professionalism and comfort."
    },
    {
      "name": "Wedding Bus Hire in Hadapsar",
      "description": "Wedding Bus Hire in Hadapsar delivers dependable wedding transportation services within the Hadapsar region. Offering a range of buses suitable for various group sizes, this service ensures timely pickups, clean vehicles, and experienced drivers, contributing to stress-free wedding travel logistics."
    },
    {
      "name": "Affordable Wedding Bus Pune",
      "description": "Affordable Wedding Bus Pune provides cost-effective bus rental options for weddings without compromising quality or safety. Ideal for budget-conscious clients, this service features well-maintained vehicles and professional drivers, making wedding transportation accessible and reliable."
    },
    {
      "name": "Wedding Bus Hire near Me Pune",
      "description": "Wedding Bus Hire near Me Pune offers localized and prompt access to wedding bus rentals across Pune. Emphasizing quick response times, flexible booking options, and professional service, this option makes it convenient for customers to arrange wedding transportation close to their location."
    },
    {
      "name": "Online Marriage Bus Booking Pune",
      "description": "Online Marriage Bus Booking Pune provides a modern, user-friendly platform for reserving wedding buses online. Featuring instant booking confirmation, multiple bus options, and secure payment methods, this service simplifies wedding transport planning, helping customers organize travel effortlessly."
    },
    {
      "name": "Wedding Transportation Pune",
      "description": "Wedding Transportation Pune encompasses comprehensive travel services for all wedding-related journeys. From guest transfers and bridal party transport to shuttle services between venues, this service ensures coordinated, comfortable, and timely movement for all participants, enhancing the overall wedding experience."
    },
    {
      "name": "Bride Guest Bus Pune",
      "description": "Bride Guest Bus Pune specializes in transporting guests attending the bride’s side of the wedding. Offering dedicated buses with ample seating and comfort, this service ensures smooth and timely travel for the bride’s family and friends, contributing to a well-organized and joyous celebration."
    }
  ],
  "tableData": [
    ["Wedding Bus Booking Online Pune", "Wedding Bus Hire Pune"],
    ["Marriage Bus Rental Pune", "AC Wedding Bus Pune"],
    ["Non AC Wedding Bus Pune", "Luxury Wedding Bus Pune"],
    ["35 Seater Wedding Bus Pune", "45 Seater Wedding Bus Pune"],
    ["53 Seater Wedding Bus Pune", "Mini Wedding Bus Pune"],
    ["Wedding Bus Hire in Baner", "Wedding Bus Hire in Hinjewadi"],
    ["Wedding Bus Hire in Hadapsar", "Affordable Wedding Bus Pune"],
    ["Wedding Bus Hire near Me Pune", "Online Marriage Bus Booking Pune"],
    ["Wedding Transportation Pune", "Bride Guest Bus Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Wedding Bus Booking Online Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers seamless online wedding bus booking services in Pune, ensuring timely and comfortable transportation for your special day."
  },
  {
    "WhyChooseheading": "Wide Range of Bus Options",
    "WhyChoosedescription": "Choose from various bus sizes to accommodate your wedding guests comfortably and stylishly."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our buses are regularly serviced and sanitized to guarantee a safe and pleasant journey for all passengers."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Enjoy upfront pricing with no hidden fees, making your wedding transportation hassle-free and budget-friendly."
  },
  {
    "WhyChooseheading": "Flexible Booking and Rental Options",
    "WhyChoosedescription": "Book hourly, daily, or customized packages that fit your wedding schedule and guest count."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our experienced drivers ensure punctuality and a smooth ride, allowing you to focus on your celebrations."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with your booking and any last-minute changes."
  },
  {
    "WhyChooseheading": "Easy and Quick Online Booking",
    "WhyChoosedescription": "Reserve your wedding bus conveniently online with prompt confirmation and reliable service across Pune."
  }
]






























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer wedding bus booking services online in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides convenient online wedding bus booking services in Pune to make your special day hassle-free.',
  },
  {
    question: 'How can I book a wedding bus online in Pune with Amruta Travels?',
    answer: 'You can easily book your wedding bus online through our website or mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of buses are available for wedding bookings in Pune?',
    answer: 'We offer a variety of buses including mini buses, 17 seater Urbania, 35 seater, 45 seater, 50 seater, and 53 seater buses perfect for wedding events.',
  },
  {
    question: 'Are the drivers experienced for wedding bus services in Pune?',
    answer: 'Yes, our drivers are professional, courteous, and experienced in providing safe and timely transportation for weddings.',
  },
  {
    question: 'Can buses be booked for all wedding-related events in Pune?',
    answer: 'Absolutely. Our buses are ideal for wedding ceremonies, receptions, guest transportation, and other wedding-related travel needs.',
  },
  {
    question: 'Is the wedding bus booking service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 wedding bus booking services in Pune to suit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for wedding bus bookings?',
    answer: 'All vehicles are thoroughly sanitized before each trip, and drivers follow strict hygiene and safety protocols to ensure your peace of mind.',
  },
  {
    question: 'What payment options are available for wedding bus bookings in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the wedding bus rental period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your wedding bus rental.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'Booking a wedding bus online with Amruta Travels Pune was smooth and easy. The bus was clean and the driver punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shweta Kulkarni',
    feedback: 'Excellent wedding bus service from Amruta Travels. They made our wedding transportation stress-free and comfortable.',
    rating: 5,
  },
];



































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Bus Booking Online Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/16.jpg",
  "description": "Book Wedding Bus Online in Pune with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, and Luxury buses for wedding guests, bride & groom transportation, and outstation functions. Affordable and reliable wedding bus rental service in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "16250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/wedding-bus-booking-online-pune"
  }
};










  return (
    <div>
<Helmet>
  <title>Wedding Bus Booking Online Pune | Luxury & AC Marriage Bus Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Wedding Bus Online in Pune with Amruta Travels Pvt. Ltd. Offering AC, Non-AC, and Luxury buses for wedding guests, bride & groom transport, and outstation events. Reliable and affordable wedding bus hire in Pune."
  />
  <meta
    name="keywords"
    content="Wedding Bus Booking Online Pune, Wedding Bus Hire Pune, Marriage Bus Rental Pune, AC Wedding Bus Pune, Non AC Wedding Bus Pune, Luxury Wedding Bus Pune, 35 Seater Wedding Bus Pune, 45 Seater Wedding Bus Pune, 53 Seater Wedding Bus Pune, Mini Wedding Bus Pune, Wedding Bus Hire in Baner, Wedding Bus Hire in Hinjewadi, Wedding Bus Hire in Hadapsar, Affordable Wedding Bus Pune, Wedding Bus Hire near Me Pune, Online Marriage Bus Booking Pune, Wedding Transportation Pune, Bride Guest Bus Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Weddingbusbookingonlinepune;